import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => (
  <div className="ds-page">
    <main className="content home-content">
      <h1>Plantilla VPO para Crear Front PWA based</h1>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginTop: 16 }}>
        <Link to="/OrquestadorMahou" className="app-btn app-btn--primary app-btn--with-icon app-btn--arrow-right">
          Abrir Orquestador Mahou
        </Link>
        <Link to="/DS" className="app-btn app-btn--secondary app-btn--with-icon app-btn--arrow-right">
          Abrir Design System
        </Link>
      </div>
    </main>
  </div>
);

export default Home;
